import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "tooltip-arrow" }, null, -1 /* HOISTED */)
const _hoisted_3 = { class: "tooltip-inner" }


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
    tooltip: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['info-tooltip', !_ctx.$slots.default && _ctx.tooltip ? 'form-label__icon form-label__icon--info' : '']),
    "aria-hidden": "true"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.tooltip)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tooltip), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})